import { QueryClient } from "react-query";
/**
 * How long an unobserved query stays in the cache. Data is never kept for
 * later visits (every mount refetches), but the time must not be 0: react-query
 * v3 drops a query with cacheTime 0 the moment its last observer unsubscribes,
 * even while its request is still running. React StrictMode (enabled by
 * stripes-core) unsubscribes and resubscribes every observer once on mount in
 * development, so with 0 the running search was dropped and sent a second time.
 * Any non-zero time keeps an in-flight query until its request settles.
 */
export var UNOBSERVED_QUERY_CACHE_TIME_MS = 1;
/** The react-query client every page of the module shares (see `index.js`). */
export var createAgencyQueryClient = function () {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 0,
                cacheTime: UNOBSERVED_QUERY_CACHE_TIME_MS,
                refetchOnWindowFocus: false,
                refetchOnMount: true,
            },
        },
    });
};
